<template>
	<div
		:class="[item.selected==true?'border-primary u:border':'']"
		class="card shadow-sm u:bg-white-1 h-100">
		<div class="row no-gutters h-100">
            <div class="col-3 ">
                <img class="rounded-left h-100 w-100 u:object-fit-cover" :src="item.content.image" alt="Suresh Dasari Card">
            </div>
            <div class="col-9">
                <div class="card-body">
                    <div class="row no-gutters">
						<div class="col-8">
							<div class="w-100 d-flex">
								<md-icon v-if="item.relatedTo=='TransportServices'" icon="flight" />
								<md-icon v-else icon="inventory" />

								<h5 class="ml-2 card-title">{{item.content.name}}</h5>
							</div>
							<p class="card-text" v-html="extractTextFromHtml(item.content.description, 70)"></p>
							<button class="border border-secondary btn-sm" @click="$emit('showDetails')">Ver mas</button>
						</div>
						<div class="col-4">
							<div class="h-100 d-flex flex-column">
								<!-- <div class="w-100 text-right">{{item.refundable?'Reembolsable':''}}</div> -->
								<div class="flex-grow-1 d-flex flex-column justify-content-end aling-item-center">
									<strong class="text-primary mb-1 w-100 text-right text-uppercase"><span class="u:text-size-1 font-weight-normal">desde</span> {{item.priceCurrency + '$'+extractFirstPrice(item.prices)}}</strong>
									<button v-if="item.selected==false" @click="$emit('showConfirmQuantity', item)" class="align-self-end btn btn-success">Agregar</button>
									<button v-else @click="$emit('showConfirmQuantity')" class="align-self-end btn btn-success">Editar</button>
								</div>
							</div>
						</div>
					</div>
                </div>
            </div>
        </div>
	</div>

</template>

<script>
export default {
	props:{
		item: Object
	},
	methods:{
		extractFirstPrice(prices){
			//filtramos los precios mayores a 0,
			// retornamos el precio mas bajo de todo el arreglo
			//usando la funcion math y extraendo los valores con map
			return Math.min.apply(null, prices.filter(opt=>opt.price>0).map(function(item) {
					return item.price;
				}
			))
		},
		extractTextFromHtml(s, max_chars=50) {
			//recuperamos el texto del html
			const span = document.createElement('span');
			span.innerHTML = s;
			let elemento = span.textContent || span.innerText;
			//creamos el limite de caracteres que se debe mostrar
			if (elemento.length > max_chars){
				return elemento.substr(0, max_chars)+" ...";
			}else{
				return elemento;
			}
		},
	}
};
</script>
<style scoped>
.u\:border{
	border-width: 0.2rem!important;
	border-radius: 0.5rem;
}
</style>
